/* External */
import { Map } from 'immutable';

/* Ott-common */
import {
  SeasonEntity,
  ShowEntity,
  ChannelEntity,
  CarouselEntity,
  ContentEntity,
  ScheduleEntity,
} from '@dtvgo/backend-service/normalize';

/* Utils */
import { getPageEntityModel } from '../utils/functions';

import createModel from './utils/createModel';

const PageEntityModel = getPageEntityModel();

export const Season = createModel(SeasonEntity, 'Season');
export const Show = createModel(ShowEntity, 'Show');
export const Channel = createModel(ChannelEntity, 'Channel', {
  schedules: (oldVal, newVal) => {
    if (!newVal) return oldVal;

    const newCreatedVal = Map(newVal).sortBy((scheduleId, key) => +(key.split('_')[0]));
    if (!oldVal) return newCreatedVal;

    const oldEntries = oldVal.entries();
    const newEntries = newCreatedVal.entries();

    return oldVal.withMutations((mutable) => {
      let currentFromOld = oldEntries.next();
      let currentFromNew = newEntries.next();
      while (!currentFromNew.done) {
        const [newKey, newValue] = currentFromNew.value;
        if (currentFromOld.value) {
          const [oldKey] = currentFromOld.value;

          if (oldKey === newKey) {
            mutable.set(oldKey, newValue);
            currentFromOld = oldEntries.next();
            currentFromNew = newEntries.next();
          } else {
            const [startTimeOld, endTimeOld] = oldKey.split('_').map((t) => +t);
            const [startTimeNew, endTimeNew] = newKey.split('_').map((t) => +t);

            if (startTimeNew >= endTimeOld) {
              currentFromOld = oldEntries.next();
            } else if (endTimeNew <= startTimeOld) {
              mutable.set(newKey, newValue);
              currentFromNew = newEntries.next();
            } else if (
              isScheduleOverlapping({
                startTimeOld,
                endTimeOld,
                startTimeNew,
                endTimeNew,
              })
            ) {
              mutable.delete(oldKey);
              currentFromOld = oldEntries.next();
            }
          }
        } else {
          mutable.set(newKey, newValue);
          currentFromNew = newEntries.next();
        }
      }
    });
  },
});
export const Schedule = createModel(ScheduleEntity, 'Schedule');
export const Page = createModel(PageEntityModel, 'Page');
export const Content = createModel(ContentEntity, 'Content');
export const Carousel = createModel(CarouselEntity, 'Carousel');

function isScheduleOverlapping({
  startTimeOld,
  endTimeOld,
  startTimeNew,
  endTimeNew,
}) {
  return (
    (startTimeOld < startTimeNew && startTimeNew < endTimeOld)
      || (startTimeOld < endTimeNew && endTimeNew < endTimeOld)
      || (startTimeNew < endTimeOld && endTimeOld < endTimeNew)
      || (startTimeNew < startTimeOld && startTimeOld < endTimeNew)
  );
}
